// extracted by mini-css-extract-plugin
module.exports = {"borderedCardContainer":"src-lib-app-components-elements-containers-BorderedCard-index-module__borderedCardContainer--2E_LC"};